import React from "react";
import { mergeClass } from "../../../functions/function";

const HeadingH3 = ({
  children,
  className,
  ...rest
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  const classHeading = mergeClass("heading-3", className);

  return (
    <h3 className={classHeading} {...rest}>
      {children}
    </h3>
  );
};

export default HeadingH3;
